module.exports = __webpack_public_path__ + "img/sarana_n.b3beb189.webp";